import Field from './Field'
import { isValid, fromModel, toModel, assignValues, assignErrors, shouldDisplayErrors } from '../utils/fields'
import underscorize from '../utils/underscorize'
import Cmd from '../utils/Cmd'

const { assign, keys } = Object

export default function Form( { formFields, validate } ) {
  const fieldNames = keys(formFields)
  const fromM = fromModel(formFields)
  const toM = toModel(fieldNames)

  const init = ({ model, afterSubmit }) => {
    const errors = validate(model)
    const [fields, fieldCmd] = fromM(model, afterSubmit, errors)
    const displayErrors = shouldDisplayErrors(fields)
    const valid = keys(errors).length === 0
    return  [
      { fields, model, displayErrors, valid },
      fieldCmd.tag("FIELD_ACTION")
    ]
  }

  const update = (state, action) => {
    switch(action.type) {
      case "FIELD_ACTION": {
        const [fieldState, fieldCmd] = Field.update(state.fields[action.field], action.payload)
        const newFields = assign({}, state.fields, { [action.field]: fieldState })
        const model = toM(newFields)
        let fields = newFields
        if (action.payload.type == "CHANGE" || action.payload.type == "BLUR") {
          const errors = validate(model)
          fields = assignErrors({ [action.field]: errors[action.field] || [] }, newFields)
        }
        const displayErrors = shouldDisplayErrors(fields)
        const valid = isValid(fields)
        return [
          assign({}, state, { fields, model, displayErrors, valid} ),
          fieldCmd.tag("FIELD_ACTION")
        ]
      }
      case "FIELD_VALIDATION_START": {
        const [fieldState, fieldCmd ] = Field.update(state.fields[action.field], { type: 'START_VALIDATION' })
        const fields = assign({}, state.fields, { [action.field]: fieldState })
        return [
          assign({}, state, { fields } ),
          fieldCmd.tag("FIELD_ACTION")
        ]
      }
      case "FIELD_VALIDATION_FINISH": {
        const [fieldState, fieldCmd] = Field.update(state.fields[action.field], { type: 'FINISH_VALIDATION',
          errors: action.errors })
        const fields = assign({}, state.fields, { [action.field]: fieldState })
        const displayErrors = shouldDisplayErrors(fields)
        const valid = isValid(fields)
        return [
          assign({}, state, { fields, displayErrors, valid }),
          fieldCmd.tag("FIELD_ACTION")
        ]
      }
      case "SET_VALUES": {
        const newFields = assignValues(action.values, state.fields)
        const model = toM(newFields)
        const errors = validate(model)
        const fields = assignErrors(errors, newFields)
        const displayErrors = shouldDisplayErrors(newFields)
        const valid = isValid(fields)
        return [
          assign({}, state, { fields, model, displayErrors, valid}),
          Cmd.none
        ]
      }
      default:
        return [state, Cmd.none]
    }
  }

  const fieldElement = ($parent, fieldName) => $parent.find(`[name*='[${underscorize(fieldName)}]']`)

  const view = ($element, state, dispatch) => {
    fieldNames.forEach( (field) => {
      Field.view(
        fieldElement($element, field),
        state.fields[field],
        (action) => {
          dispatch({ type: "FIELD_ACTION", field: field, payload: action })
        }
      )
    })
  }

  return { init, update, view /* fromModel: fromM, toModel: toM */ }
}
